export default __webpack_public_path__ + "static/media/aj3.71fa0c36.png";